import React, { useState, useEffect, useRef } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Button, Loader } from 'rsuite';

const Cropper = ({ imageToCrop, handleCropping, croppedImage }) => {
  const [crop, setCrop] = useState({
    unit: '%', // To use percentage values for cropping
    width: 100, // Initial crop width in percentage
    height: 100, // Initial crop height in percentage
  });

  const [image, setImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(imageToCrop);
  const [loading, setLoading] = useState(true);
  const [cropLoading, setCropLoading] = useState(false);

  const canvasRef = useRef(null);

  // Convert remote image URL to Data URL or Blob URL if necessary
  useEffect(() => {
    if (imageToCrop && !imageToCrop.startsWith('data:')) {
      // If image is not already a Data URL or Blob URL, fetch it
      fetchImage(imageToCrop);
    } else {
      setLoading(false)
      setImageSrc(imageToCrop); // Otherwise, use the image directly
    }
  }, [imageToCrop]);

  // Fetch image and convert it to Data URL or Blob URL
  const fetchImage = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob); // Convert to Blob URL
      setImageSrc(blobUrl); // Set the Blob URL for cropping
      setLoading(false);
    } catch (error) {
      console.error('Error fetching image:', error);
    }
  };

  const onImageLoaded = (img) => {
    setImage(img);
  };
  const cropImageNow = () => {
    setCropLoading(true)
    console.log("IMAGE :", image)
    if (!image || !canvasRef.current || !crop.width || !crop.height) return;

    const canvas = canvasRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      // Calculate the exact dimensions of the cropped area in the original image
      const cropWidth = crop.width * scaleX;
      const cropHeight = crop.height * scaleY;

      // Set the canvas size to match the cropped area dimensions
      canvas.width = cropWidth;
      canvas.height = cropHeight;

      // Set the background to white (optional, useful for transparent images)
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw the cropped area onto the canvas
      ctx.drawImage(
        image,
        crop.x * scaleX, // Start X in original image
        crop.y * scaleY, // Start Y in original image
        cropWidth,       // Width of the cropped area
        cropHeight,      // Height of the cropped area
        0,               // Destination X
        0,               // Destination Y
        cropWidth,       // Width of the cropped area on the canvas
        cropHeight       // Height of the cropped area on the canvas
      );

      // Convert the canvas content to a Blob
      canvas.toBlob((blob) => {
        if (blob) {
          // Create a URL for the Blob object (Blob URL)
          console.log('hi');
          const croppedUrl = URL.createObjectURL(blob);
          console.log('croppedUrl', croppedUrl);
          croppedImage(croppedUrl); // Pass the URL of the cropped image to the parent
          handleCropping();
        }
      }, 'image/jpeg'); // Specify the image format (JPEG or PNG)
    }
    // setCropLoading(false)
  };

  return (
    <div>
      <div>
        {imageSrc && !loading ? (
          <ReactCrop
            src={imageSrc}
            onImageLoaded={onImageLoaded}
            crop={crop}
            onChange={setCrop}
            ruleOfThirds
            crossOrigin="anonymous" // Set crossOrigin for cross-origin images
          />
        ) : (
          <p>Loading image...</p>
        )}
        <br />
        <Button
          style={{
            width: '76px',
            display: 'flex',
            margin: 'auto',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
          size='sm' appearance='primary' color='blue'
          onClick={cropImageNow}>
          <p>
            Crop
          </p>
          {cropLoading && <Loader size='sm' />}
        </Button>
        <br />
      </div>
      <canvas ref={canvasRef} style={{ display: 'none' }} />
    </div>
  );
};

export default Cropper;
